function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import { motion, useReducedMotion } from "framer-motion";
import React from "react";
import { BlockBackgroundShape } from "../Molecules/blocks/BlockBackgroundShape";
import { BlockBlogListing } from "../Molecules/blocks/BlockBlogListing";
import { BlockCookiePreferences } from "../Molecules/blocks/BlockCookiePreferences";
import { BlockHtmlEmbed } from "../Molecules/blocks/BlockHtmlEmbed";
import { BlockLogoListing } from "../Molecules/blocks/BlockLogoListing";
import { BlockPageListing } from "../Molecules/blocks/BlockPageListing";
import { Facts } from "../Molecules/blocks/Facts";
import FullWidthImage from "../Molecules/blocks/FullWidthImage";
import Image from "../Molecules/blocks/Image";
import ImagesWithBackground from "../Molecules/blocks/ImagesWithBackground";
import MobileImages from "../Molecules/blocks/MobileImages";
import Prose from "../Molecules/blocks/Prose";
import Intro from "../Molecules/Intro";
import { GridLogos } from "./GridLogos";
import { Vision } from "./Homepage/Vision";
import { Team } from "./Team";
export function StandardPage(props) {
    var avoidAnimation = useReducedMotion();
    return /*#__PURE__*/ React.createElement(motion.main, {
        id: "main-content",
        className: "flex-1 relative z-10 max-w-full bg-light-grey",
        initial: avoidAnimation ? {
            opacity: 1,
            x: 0
        } : {
            opacity: 0,
            x: -200
        },
        animate: {
            opacity: 1,
            x: 0
        },
        exit: avoidAnimation ? {
            opacity: 1,
            x: 0
        } : {
            opacity: 0,
            x: 200
        },
        transition: {
            type: "spring",
            mass: 0.35,
            stiffness: 75,
            duration: 0.3
        }
    }, !props.image ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Intro, {
        title: props.title,
        lead: props.lead,
        color: props.headingColor,
        size: props.headingSize,
        backgroundShape: props.backgroundShape
    })) : null, /*#__PURE__*/ React.createElement("div", {
        className: "my-16 relative"
    }, props.content.map(function(block, index) {
        switch(block.__typename){
            case "BlockText":
                return /*#__PURE__*/ React.createElement(Prose, {
                    key: index,
                    content: block.content,
                    columnLists: true,
                    headingColor: props.headingColor,
                    className: block === null || block === void 0 ? void 0 : block.className
                });
            case "BlockImage":
                return /*#__PURE__*/ React.createElement(Image, _extends({}, block));
            case "BlockFacts":
                return /*#__PURE__*/ React.createElement(Facts, {
                    facts: block.facts
                });
            case "BlockFullWidthImage":
                return /*#__PURE__*/ React.createElement(FullWidthImage, _extends({}, block));
            case "BlockLogoCloud":
                return /*#__PURE__*/ React.createElement(GridLogos, _extends({}, block.logoCloud));
            case "BlockMobileImages":
                return /*#__PURE__*/ React.createElement(MobileImages, _extends({}, block));
            case "BlockImagesWithBackground":
                return /*#__PURE__*/ React.createElement(ImagesWithBackground, _extends({}, block));
            case "BlockPageListing":
                return /*#__PURE__*/ React.createElement(BlockPageListing, _extends({}, block));
            case "BlockBlogListing":
                return /*#__PURE__*/ React.createElement(BlockBlogListing, _extends({}, block));
            case "BlockTeamListing":
                return /*#__PURE__*/ React.createElement(Team, _extends({}, block));
            case "BlockLogoListing":
                return /*#__PURE__*/ React.createElement(BlockLogoListing, _extends({}, block));
            case "BlockMissionStatement":
                return /*#__PURE__*/ React.createElement(Vision, _extends({}, block));
            case "BlockBackgroundShape":
                return /*#__PURE__*/ React.createElement(BlockBackgroundShape, _extends({}, block));
            case "BlockCookiePreferences":
                return /*#__PURE__*/ React.createElement(BlockCookiePreferences, _extends({}, block));
            case "BlockHtmlEmbed":
                return /*#__PURE__*/ React.createElement(BlockHtmlEmbed, _extends({}, block));
            case "BlockError":
                return /*#__PURE__*/ React.createElement("p", null, block.message);
        }
    })));
}
